module.exports = __webpack_public_path__ + "img/house-2.7fb0024f.jpg";